








































import Vue from "vue";
import VariableInput from "@/components/util/VariableInput.vue";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import {
  authPhoneNumberRegExp,
  authPhoneNumberLengthLimit,
  authPhoneNumberConstraintErrorMessage,
  codeConstraintErrorMessage,
  codeLengthLimit,
  codeRegExp,
} from "@/views/forms/constraint";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";
import { createAuthCode, changePhoneNumber, checkDuplicatePhoneNumber } from "@/api/UserProfile";
import { validateAuthCode } from "@/api/AuthCode";

export default Vue.extend({
  name: "SettingsMailAddress",
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    "accountData.phoneNumber"(phoneNumber: string) {
      this.inputs["phoneNumber"].error =
        phoneNumber.length <= authPhoneNumberLengthLimit && authPhoneNumberRegExp.test(phoneNumber)
          ? ""
          : authPhoneNumberConstraintErrorMessage;
          this.checkPhoneNumber();
    },
    "accountData.code"(code: string) {
      this.inputs["code"].error =
        code.length <= codeLengthLimit && codeRegExp.test(code) ? "" : codeConstraintErrorMessage;
    },
  },
  data() {
    return {
      accountData: {
        phoneNumber: "",
        code: "",
      },
      inputs: {
        phoneNumber: {
          name: "電話番号",
          type: "text",
          placeholder: "新しい電話番号",
          constraint: authPhoneNumberConstraintErrorMessage,
          error: "",
          ok: "",
        },
        code: {
          name: "認証コード",
          type: "text",
          placeholder: "認証コード",
          constraint: codeConstraintErrorMessage,
          error: "",
        },
      },
      isAuthCodeEnter: false,
      isDapulicate: false,
    };
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      if (this.isAuthCodeEnter) {
        return !(
          this.accountData.code.length <= codeLengthLimit &&
          codeRegExp.test(this.accountData.code)
        );
      }
      return !(
        this.accountData.phoneNumber.length <= authPhoneNumberLengthLimit &&
        authPhoneNumberRegExp.test(this.accountData.phoneNumber) && !this.isDapulicate
      );
    },
    getUserId(): string {
      return this.$store.getters.userProfile.userId;
    },
    getLastFourDigits(): string {
      return this.accountData.phoneNumber.substring(7, this.accountData.phoneNumber.length);
    },
  },
  methods: {
    async onClickSubmit() {
      let isValidated = false;
      try {
        // 認証コードを検証する
        let res = await validateAuthCode({
          userId: this.$store.state.user.userId,
          authCode: this.accountData.code,
          purpose: "電話番号変更",
        });
        isValidated = res.isValidated;
        if(!isValidated){
          this.inputs.code.error = res.message;
          return;
        }
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit("errorToast", resError.message);
          }
        }
        return;
      }

      // 検証結果がtrueであれば電話番号の変更を行う
      if (isValidated) {
        try {
          // 電話番号変更リクエスト要求
          await changePhoneNumber({
            newPhoneNumber: this.accountData.phoneNumber,
          });
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message != null) {
              this.$emit("errorToast", resError.message);
            }
          }
          return;
        }
      }
      // 設定画面に遷移し、更新した旨を表示する
      this.toAccountSettings();
      this.$emit("toast", "電話番号を更新しました。");
    },
    toAccountSettings() {
      this.$router.push({ name: "Settings", params: { modeName: "account" } });
    },
    /**
 * 電話番号の重複チェックをし, それに応じたメッセージを設定する
 */
 async checkPhoneNumber() {
      if (!authPhoneNumberRegExp.test(this.accountData.phoneNumber)) {
        this.inputs["phoneNumber"].ok = "";
      this.inputs["phoneNumber"].error =
        authPhoneNumberRegExp.test(this.accountData.phoneNumber) && this.accountData.phoneNumber.length <= authPhoneNumberLengthLimit
          ? ""
          : authPhoneNumberConstraintErrorMessage;
        return;
      }
      const res = await checkDuplicatePhoneNumber({
        userId: this.$store.state.user.userId,
        inputPhoneNumber: this.accountData.phoneNumber,
       });

      if (res.isDuplicate) {
        this.inputs["phoneNumber"].error = res.message;
        this.isDapulicate = true;
      } else {
        this.inputs["phoneNumber"].error = '';
        this.inputs["phoneNumber"].ok = res.message;
        this.isDapulicate = false;
      }
    },
    /**
     * 認証コード入力画面を表示して、コード送信リクエストを要求
     *
     */
    async sendAuthCode() {
      try {
        await createAuthCode({
          userId: this.$store.state.user.userId,
          phoneNumber: this.accountData.phoneNumber,
          purpose: "電話番号変更",
        });
        this.isAuthCodeEnter = true;
        this.$emit("toast", "認証コードを送信しました。");
      } catch (e) {
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message != null) {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
  },
});
